import React, { useEffect, useState } from "react";
import { GeneralStyleClientAccess } from "./ClientAccessContainer.styled";
import { useLazyQuery } from "@apollo/client";
import {
  MENU_MODULE_LIST,
  CLIENT_MODULES_BY_MENU,
  GET_CLIENTS,
} from "../../GraphQL/Queries";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import MaterialTable from "material-table";
import Checkbox from "@mui/material/Checkbox";
import { theme as themeConfig } from "../../themes/themes";

const ClientAccessContainer = () => {
  const [menuModules, setMenuModules] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [clientModulesList, setClientModulesList] = useState({});

  const [runQueryMenuModulesList, { loading: loadingMenuModules }] =
    useLazyQuery(MENU_MODULE_LIST, {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        setMenuModules(data.moduleList);
      },
    });

  const [runQueryClientByMenus, { loading: loadingClientsByMenus }] =
    useLazyQuery(CLIENT_MODULES_BY_MENU, {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        const menusByClientData = { ...clientModulesList };
        data.currentClient.modules.forEach((element) => {
          menusByClientData[data.currentClient.clientName] =
            menusByClientData[data.currentClient.clientName] ?? {};
          menusByClientData[data.currentClient.clientName][
            element.moduleId
          ] = true; // element.recordState;
        }); // Parameter is not there in the api so hard coding here true for temporary, changes made as part of data centralization
        setClientModulesList(menusByClientData);
      },
    });

  const [runQueryGetClients, { loading: loadingGetClients }] = useLazyQuery(
    GET_CLIENTS,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        setClientList(data.clientList);
      },
    }
  );

  useEffect(() => {
    runQueryMenuModulesList({
      context: { clientName: "LinkUsers" },
    });
    runQueryGetClients({
      context: { clientName: "LinkUsers" },
    });
  }, []);

  useEffect(() => {
    if (!menuModules.length) {
      return;
    }
    runQueryClientByMenus({
      context: { clientName: "LinkUsers" },
    });
  }, [menuModules]);

  return (
    <GeneralStyleClientAccess>
      {(loadingMenuModules || loadingGetClients || loadingClientsByMenus) && (
        <ModalLoader></ModalLoader>
      )}
      {!loadingMenuModules && !loadingGetClients && !loadingClientsByMenus && (
        <MaterialTable
          style={{ margin: "0 1rem 0 1rem" }}
          title=""
          columns={[
            { title: "Client", field: "clientName" },
            ...menuModules.map((element, index) => ({
              title: element.name,
              field: "checkbox" + index,
            })),
          ]}
          data={clientList.map((element) => ({
            clientName: element.clientName,
            ...menuModules.reduce((acc, current, index) => {
              acc[`checkbox${index}`] = (
                <Checkbox
                  checked={
                    !!clientModulesList?.[element.clientName]?.[
                      current.moduleId
                    ]
                  }
                  sx={{
                    color: themeConfig.primary.greenDark,
                    "&.Mui-checked": {
                      color: themeConfig.primary.greenDark,
                    },
                  }}
                />
              );
              return acc;
            }, {}),
          }))}
          options={{
            search: false,
            paging: false,
            headerStyle: {
              zIndex: 1,
              fontWeight: "bold",
            },
          }}
        />
      )}
    </GeneralStyleClientAccess>
  );
};

export default ClientAccessContainer;
